import { render, staticRenderFns } from "./pickList.vue?vue&type=template&id=fbc33e9a&scoped=true"
import script from "./pickList.vue?vue&type=script&lang=js"
export * from "./pickList.vue?vue&type=script&lang=js"
import style0 from "./pickList.vue?vue&type=style&index=0&id=fbc33e9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc33e9a",
  null
  
)

export default component.exports